module.exports = __webpack_public_path__ + "media/images/application/template/email-4a81b65f18718f29e0ff522e2935b89c.svg";